/**
 * @file 请求方法基础，适用于paddle文档的搜索文档接口
 * @author wanzhongyun
 */

import {message} from 'antd';
import request from 'superagent';


const baseRequest = async (superagentObject: Promise<any>): Promise<request.Response> => {
    let res: request.Response;
    try {
        res = await superagentObject;
        const body = res.body;
        if (!body) {
            throw new Error('网络好像有点问题');
        }
    }
    catch (err: any) {
        (window as any).DEBUG && message.error(err.message);
        throw err;
    }

    return res;
};

export default baseRequest;
